'use strict';

var average = require('./average');

module.exports = average;


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/avg.js
// module id = ./node_modules/collect.js/dist/methods/avg.js
// module chunks = 0